import React from "react";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

function TestingSummary({ latestRun, isRunning }) {
    const { t } = useTranslation();

    if (!latestRun && !isRunning) return null;

    const summary = latestRun?.summary || { total: 0, passed: 0, failed: 0 };
    const passRate = summary.total > 0
        ? Math.round((summary.passed / summary.total) * 100)
        : 0;
    const duration = latestRun?.duration
        ? `${(latestRun.duration / 1000).toFixed(1)}s`
        : "--";
    const timeAgo = latestRun?.completedAt
        ? getTimeAgo(new Date(latestRun.completedAt))
        : "";

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            {isRunning ? (
                <div className="flex items-center gap-2 text-sm text-blue-600">
                    <Loader2 className="w-4 h-4 animate-spin" />
                    {t("testing.executingTests") || "Executing tests..."}
                </div>
            ) : (
                <>
                    <div className="flex items-center justify-between text-sm text-gray-600 mb-2">
                        <span>
                            {t("testing.lastRun") || "Last Run"}:{" "}
                            {summary.passed}/{summary.total}{" "}
                            {t("testing.passed") || "passed"} &bull; {duration}
                            {timeAgo && ` \u2022 ${timeAgo}`}
                        </span>
                        <span
                            className={
                                latestRun?.status === "passed"
                                    ? "text-green-600 font-medium"
                                    : "text-red-600 font-medium"
                            }
                        >
                            {passRate}% {t("testing.passed") || "passed"}
                        </span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                        <div
                            className={`h-2 rounded-full transition-all ${
                                latestRun?.status === "passed"
                                    ? "bg-green-500"
                                    : "bg-red-500"
                            }`}
                            style={{ width: `${passRate}%` }}
                        />
                    </div>
                </>
            )}
        </div>
    );
}

function getTimeAgo(date) {
    const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
    if (seconds < 60) return `${seconds}s ago`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    return `${Math.floor(hours / 24)}d ago`;
}

export default TestingSummary;
